<template>
    <v-dialog  
        z-index="100" 
        :style="' --zIndex:101;'"
        class="mbs-z-index" 
        v-model="show" 
        :max-width="mbs_dialog.size?mbs_dialog.size:500"                     
        :persistent='mbs_dialog.fixed'  >
        <v-card class="">
            <v-card-title class="primary headline">
                <v-layout > 
                    <div class="font-weight-bold b2--text"> 
                        <span >{{title?title:' BLUETOOTH PRINTER'}}</span> 
                    </div> 
                    <v-spacer></v-spacer> 
                    <v-btn class="ml-9" @click="CLOSE_DIALOG()" icon dark><v-icon >close</v-icon></v-btn>
                </v-layout>
            </v-card-title>
             
            <v-card-text>
                <form @submit.prevent="connect({...input_bluetooth_printer||{},key:input_selected_printer_key})" >
                    <v-card class="mt-3 mb-3" flat>
                        <v-card class="mt-3 mb-3" min-height="80" outlined tile>
                            <v-list   >
                                
                                <v-autocomplete v-model="input_selected_printer_key"
                                    class="mx-2 mt-3"    
                                    :label="'Printer'"
                                    prepend-inner-icon="mdi-printer"
                                    :items="Printers"
                                    item-text="name"
                                    item-value="key"  
                                    auto-select-first
                                    clearable
                                    dense
                                    filled
                                    rounded
                                    small-chips>
                                </v-autocomplete> 
                            </v-list>
                            <div >
                                <v-divider></v-divider>
                                <v-autocomplete v-model="input_bluetooth_printer"
                                    class="mx-2 mt-3"    
                                    :label="'Attach Bluetooth Printer'"
                                    prepend-inner-icon="mdi-bluetooth-connect"
                                    :items="devices"
                                    item-text="name"  return-object
                                    auto-select-first  
                                    clearable
                                    dense
                                    filled
                                    rounded
                                    small-chips>
                                </v-autocomplete>  
                            </div>
                            <v-subheader class="ml-">Select, attach and connect to android bluetooth printer.</v-subheader>
                        </v-card>
                        <v-layout  row wrap class="ma-0" justify-end>
                            <v-spacer></v-spacer>
                            <v-btn @click="listPairedDevices()" :loading="inputLoadingPaidDevices" class="mt-1"  color="primary" small tile ou>
                                <v-icon>mdi-refresh</v-icon>
                                Refresh paired devices
                            </v-btn>
                            <v-btn @click="openPairingSettings()" class="ml-1 mt-1" color="primary" small tile>
                                <v-icon>mdi-bluetooth-settings</v-icon>
                                Pair new device
                            </v-btn>
                        </v-layout>
                        <v-divider class="mt-5 mb-2"></v-divider>
    
                        <!-- <div v-if="permissionDenied">
                            <p>Bluetooth permission was denied. Enable it manually in app settings.</p>
                            <button @click="openAndroidAppSettings()">Open App Settings</button>
                        </div> -->
    
                        <v-alert  v-if="permissionDenied"
                            color="error"
                            border="left"
                            elevation="2"
                            colored-border
                            icon="mdi-account-key-outline"
                            >
                            Bluetooth permission was <strong>denied</strong>.  Enable it manually in app settings.
                            <v-layout row wrap> 
                                <v-spacer></v-spacer>
                                <v-btn @click="openAndroidAppSettings()" small tile class="mr-1 mb-1" color="error">Enable</v-btn>
                            </v-layout>
                        </v-alert>
    
                        <v-layout row wrap class="ma-0">
                            <v-spacer></v-spacer>
                            <v-btn @click="CLOSE_DIALOG()"   text>Cancel</v-btn>         
                            <v-btn type="submit"
                                tile  :loading="inputLoading"
                                color="secondary" class="ml-1">
                                <v-icon>mdi-content-save-outline</v-icon> Save and Connect</v-btn>
                        </v-layout>
    
                       
                    </v-card>   
                </form>
            </v-card-text>   
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapState} from "vuex" 
    import { registerPlugin } from '@capacitor/core';
    import DATA from "../../plugins/DATA";
    let NAME = 'dialog_connect_android_printer'
    const BluetoothPrinter = registerPlugin('BluetoothPrinter'); 
    export default {
        props:['title','text','btnYes','btnNo','printer_key','printer_code','till_key','till_code'], 
        data(){
            return{
                show:false,
                input:{},
                inputLoading:false,
                inputLoadingPaidDevices:false,
                input_selected_printer_key:null,
                input_bluetooth_printer:null,
                devices:null,
                permissionDenied :false,
                connectedAddress:null,
            } 
        }, 
        created(){
            this.MBS.events.$on('ON_KEY_DOWN', this.ON_KEY_DOWN); 
            this.MBS.events.$on('CONFIG_ANDROID_BLUETOOTH_PRINTER', this.CONFIG_ANDROID_BLUETOOTH_PRINTER); 
            this.listPairedDevices() 
        },
        computed:{
             vs(){
                let vs = this.$vuetify.breakpoint 
                return vs 
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            mbs_dialog(){
                return  this.$store.getters.getMBS_dialog
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                tus: state=> state.users["TEMPORARY_USER"], 
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'], 
                SHOW_OFFLINE: state=> state.items['SHOW_OFFLINE'],
                online: state=> state.users['ONLINE_STATUS'],
                SERVERS: state=> state.lan['SERVERS'],
                LAN: state=> state.lan['LAN'],
                EVENTS: state=> state.lan['EVENTS'],
                SAGE_LOADER: state=> state.lan['SAGE_LOADER'],
                SERVER_INFO: state=> state.lan['SERVER_INFO'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()],  
                Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                Tills: state=> state.items[(DATA.ITEMS.TILLS.values).toUpperCase()],
                JoinedTills: state=> state.join[(DATA.ITEMS.TILLS.values).toUpperCase()],  
                Devices: state=> state.items[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                JoinedDevices: state=> state.join[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                
                LocalCashups: state=> state.locals[(DATA.ITEMS.LOCAL_CASHUPS.values).toUpperCase()],
                LocalDevices: state=> state.locals[(DATA.ITEMS.LOCAL_DEVICES.values).toUpperCase()], 
            }), 
            DevicesData(){
                return this.JoinedDevices?this.JoinedDevices:this.Devices
            },
            OutletsData(){
                return this.JoinedOutlets?this.JoinedOutlets:this.Outlets
            }, 
            TillsData(){
                return this.JoinedTills?this.JoinedTills:this.Tills
            }, 
            Printers(){
                let devices = this.DevicesData  
                let printers = []
                if (devices) {
                    // printers = devices.filter(item=>{
                    //     return this.MBS.actions.TEXT_UP(item.device_type)
                    //      == this.MBS.actions.TEXT_UP(DATA.ITEMS.PRINTERS.value)
                    // })  
                    printers = devices.filter(item=>item.printer_type_code=="5")  
                }
                return [
                    // {
                    //     code:0,
                    //     name:"Other Installed Printer",
                    //     isDefaultPrinter:true,
                    //     priority:1
                    // },
                    ...printers
                ]
            },
            LocalCashup(){    
                let cashups = this.LocalCashups 
                let local_cashup = cashups?cashups.find(item=>{
                    return !item.closed
                }):null 
                this.day_shift_key = local_cashup?.day_shift_key 
                return local_cashup
            }, 
            CurrentTill(){
                const tills = this.TillsData
                const key = this.till_key
                const code = this.till_code
                const cashup = this.LocalCashup  
 
                const findTill = (key,code)=>{
                    return tills?.find(tl=>key?tl.key==key:tl.code==code)
                }

                let till = null
                if (key) {
                    till = findTill(key)
                } else if (code) {
                    till = findTill(null,code)
                } else if (cashup) {
                    till = findTill(cashup.till_key)
                }  
                return till
            },
            CurrentPrinter(){
                const input_selected_printer_key = this.input_selected_printer_key
                const printer_key = this.printer_key
                const printer_code = this.printer_code
                const printers = this.Printers
                const till = this.CurrentTill
                console.log(printers,'pr.............');
                

                const findPrinter = (key,code)=>{
                    return printers?.find(pr=>key?pr.key==key:pr.code==code)
                }

                let printer = null
                if (printer_key) {
                    printer = findPrinter(printer_key)
                }else if (input_selected_printer_key) {
                    printer = findPrinter(input_selected_printer_key)
                }else if (printer_code) {
                    printer = findPrinter(null,printer_code)
                }else if (till) {
                    printer = findPrinter(till.printer_key)
                } 
                return printer
            }
        },
        methods:{
            restData(){
                Object.assign(this.$data, this.$options.data()) 
            },
            async listPairedDevices() {
                try {
                    this.inputLoadingPaidDevices = true
                    const { devices } = await BluetoothPrinter.listPairedDevices();
                    this.devices = devices;
                    this.permissionDenied  = false;
                    this.inputLoadingPaidDevices  = false;
                    return devices; 
                } catch (error) {
                    this.inputLoadingPaidDevices  = false;
                    let message = error.message ? error.message : '';
                    if (message.toLowerCase().includes('permission')) {
                        this.permissionDenied = true;
                    }

                }finally {
                    this.inputLoadingPaidDevices  = false;
                    this.MBS.actions.progressDialog()
                }
            },
            async connect(bluetooth_printer) {
                this.connecting = true;
                this.error = null;
                const test_print = [
                    {
                        "align": "center",
                        "bold": false,
                        "value": "top_header",
                        "text": "*** Bluetooth printer successfully connected "+bluetooth_printer?.name+" ***"
                    },
                ]
                console.log(bluetooth_printer,'bluetooth_printer.....');
                
                try {
                    this.inputLoading = true
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Connecting..",
                    }) 
                    await BluetoothPrinter.connect(bluetooth_printer);
                    this.connectedAddress = bluetooth_printer; 
                    console.log(this.connectedAddress,'connectedAddress...........');

                    //update db
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"DB Updating...",
                    }) 
                    const updating_printer = {
                        key:this.input_selected_printer_key,
                        bluetooth_name:bluetooth_printer?.name || null,
                        bluetooth_address:bluetooth_printer?.address || null,
                    }
                    const path =this.MBS.actions.COMPANY_LINK(DATA.PATHS.devices+this.input_selected_printer_key,true) 
                    console.log({updating_printer,path},"updating_printer.................... ");
                    await this.$store.dispatch("fi_update",{
                        action:DATA.ITEMS.PRINTERS.values,
                        data:updating_printer,
                        path:path
                    })


                    //test printer
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Printing...",
                    })
                    await BluetoothPrinter.printReceipt({lines:test_print})
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Updating...",
                    })
                    this.inputLoading = false   
                    this.MBS.actions.progressDialog() 
                } catch (e) {
                    console.log(e,'Failed to connect.........'); 
                    this.error = e.message || 'Failed to connect';
                    throw e;
                } finally {
                    this.connecting = false;
                    this.inputLoading = false  
                    this.MBS.actions.progressDialog()
                }
            },
            async disconnect() {
            await BluetoothPrinter.disconnect(); 
            localStorage.removeItem(STORAGE_KEY);
            },
            async reconnectIfSaved() {
                const saved = localStorage.getItem(STORAGE_KEY);
                if (saved) {
                    try { await this.connect(saved); } catch (e) { /* stays disconnected, user can retry */ }
                }
            },
            openPairingSettings() {
                return BluetoothPrinter.openBluetoothSettings();
            }, 
            openAndroidAppSettings() {
                return BluetoothPrinter.openAppSettings();
            },
            CONFIG_ANDROID_BLUETOOTH_PRINTER(){
                this.show = true
            },
            CLOSE_DIALOG(){
                this.restData()
            }
        },
        beforeDestroy(){
            try {  
                this.MBS.events.$off('ON_KEY_DOWN', this.ON_KEY_DOWN);    
                this.MBS.events.$off('CONFIG_ANDROID_BLUETOOTH_PRINTER', this.CONFIG_ANDROID_BLUETOOTH_PRINTER);    
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{
            mbs_dialog(value){ 
            },   
        } 
    }
</script>
